import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@features/authentication/store/authStore';

/**
 * Route guard that only checks authentication (no mustChangePassword redirect).
 * Used for routes like /change-password that need auth but shouldn't
 * trigger the forced-password-change redirect loop.
 */
export function AuthenticatedRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
